export class SettlementOverviewFilter {
    hedgeDateFrom?: string;
    hedgeDateTo?: string;
    noOfDays?: number;
}
